// ProgressBar.js
import React, { FC } from "react";
import { ProgressBar } from "react-bootstrap";

interface ProgressBarComponentProps {
  progress: any;
}

const ProgressBarComponent: FC<ProgressBarComponentProps> = ({ progress }) => {
  return (
    <ProgressBar
      now={progress}
      label={`${progress}%`}
      animated
      striped
      variant="success"
    />
  );
};

export default ProgressBarComponent;
